export const pageStateSelector = (page) => (state) =>
  state.crossPageInteractionsStore[page];
